import Vue from 'vue'
import { usePluginInClient, registerComponent, registerComponentProgrammatic } from './utility'
import AcademyModalMessage from '~/components/common/Modal/ModalMessage'

// Pass props to ModalMessage dynamic, Inject ModalMessage to root level of DOM
function open(propsData) {
  const AcademyModalMessageComponent = Vue.extend(AcademyModalMessage)
  return new AcademyModalMessageComponent({
    el: document.createElement('div'),
    propsData,
  })
}

const ModalMessageProgrammatic = {
  // Open modal message without footer actions by default
  alert(params) {
    let message

    if (typeof params === 'string') {
      message = params
    }
    const defaultParam = {
      message,
      hasIcon: true,
    }
    const propsData = Object.assign(defaultParam, params)
    return open(propsData)
  },
  // Open modal message with footer actions by default
  confirm(params) {
    const defaultParam = {
      showFooter: true,
    }
    const propsData = Object.assign(defaultParam, params)
    return open(propsData)
  },
}

const AcademyModalMessagePlugin = {
  install(Vue) {
    registerComponent(Vue, AcademyModalMessage)
    registerComponentProgrammatic(Vue, 'modalMessage', ModalMessageProgrammatic)
  },
}

usePluginInClient(AcademyModalMessagePlugin)

export default AcademyModalMessagePlugin
